// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Layout":"Layout-8c5egvxq1dhdgyu24cemeh93dpm4wjv4s2er81qzhr3jnk1jmnu9p7baampferzv28gah4tzzc8yvaq76ubberfamvxfgj68dee1z6","Wrapper":"Wrapper-3n1s7by2fushxmtjkd7hvj1g995nz3b5stu2chs7sv8ggge6dr3c81nugem2w4asxmvep3rf9sm5z72ffx2fmpdbb6uzq477yfxz8qk","loading":"loading-47em8mm2qewm9rpdrj8usq3y5ykd34wkusxw93qucxagqhmpcgyc8tpr2s9nts89dwxdu8wpaqrcq3gw67zmym8egqf8bz9phrj6gse","pulse":"pulse-4frhje6bk7w68qvjzxwvr9b7harx8r19k4utmumcvyrvk3zjb3tb78t48244rw3777fg4c6qh7wazawzw8f8k87e2gnqnguxp88w91j"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Layout/Layout.module.scss
// module id = 760
// module chunks = 0